// server/HeroSection.tsx for Ziwatech project
import React from "react";
import { Link } from "wouter";
import { FaArrowRight, FaCheck } from "react-icons/fa"; // Removed unused FaChevronLeft/Right

// --- Swiper Imports ---
// 1. Import React components
import { Swiper, SwiperSlide } from 'swiper/react';
// 2. Import Swiper modules for features (Navigation, Pagination, Autoplay, EffectFade)
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
// 3. Import Swiper core styles and module styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade'; // Import fade effect CSS
// --- End Swiper Imports ---

// Assuming images are correctly served from /public/images/
const deviceImages = [
  {
    src: "/images/iphone-repair.webp",
    alt: "iPhone repair"
  },
  {
    src: "/images/samsung-repair.webp",
    alt: "Samsung phone repair in North York"
  },
  {
    src: "/images/ipad-repair.jpg",
    alt: "iPad tablet repair service North York"
  },
  {
    src: "/images/laptop-repair.webp",
    alt: "Laptop computer repair in North York"
  }
];

const HeroSection = () => {
  // Removed useState, useEffect, nextSlide, prevSlide - Swiper handles state and logic

  return (
    <section className="bg-gradient-to-r from-gray-900 to-indigo-900" aria-label="Mobile repair services in Etobicoke">
      <div className="relative max-w-7xl mx-auto px-4 py-24 sm:px-6 lg:px-8 lg:py-32">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-2 lg:gap-24 items-center">

          {/* --- Content Column (No changes needed here) --- */}
          <div className="text-center lg:text-left">
           <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
  Phone, Laptop & Console Repair in{" "}
  <span className="text-indigo-400">North York</span>
</h1>
            <p className="mt-6 text-xl text-gray-300 max-w-2xl mx-auto lg:mx-0">
              Fast, affordable repairs for phones, tablets and computers. Serving North York YorkgateMall with same-day service.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Link
                href="/booking"
                className="px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 md:py-4 md:text-lg md:px-10 transition-all"
              >
                Book Repair Now
              </Link>
              <Link
                href="/services"
                className="px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-gray-800 hover:bg-gray-700 md:py-4 md:text-lg md:px-10 transition-all flex items-center"
              >
                Our Services <FaArrowRight className="ml-2" />
              </Link>
            </div>
            <div className="mt-10 grid grid-cols-2 gap-8 text-left text-gray-300">
              {[
                "Same-Day Service",
                "Accessories",
                "Free Diagnostics",
                "Experience Technicians"
              ].map((item) => (
                <div key={item} className="flex items-center">
                  <FaCheck className="h-5 w-5 text-green-400 mr-2" />
                  {item}
                </div>
              ))}
            </div>
          </div>
          {/* --- End Content Column --- */}


          {/* --- Image Slider Column (Using Swiper) --- */}
          <div className="relative"> {/* Keep relative positioning for the info box */}
            {/* Swiper Component replaces the manual image mapping and controls */}
            <Swiper
              // Add required modules
              modules={[Navigation, Pagination, Autoplay, EffectFade]}
              effect="fade" // Use fade effect
              fadeEffect={{ crossFade: true }} // Enable cross-fading
              spaceBetween={30} // Not very relevant for fade, but good practice
              slidesPerView={1} // Fade works best with 1 slide visible
              navigation // Enable Next/Prev arrows
              pagination={{ clickable: true }} // Enable clickable dots
              autoplay={{
                delay: 5000, // Match original interval
                disableOnInteraction: false,
              }}
              loop={true} // Enable looping
              // Apply styling similar to the original container
              className="relative w-full rounded-xl overflow-hidden shadow-2xl aspect-[10/7]" // Use aspect-[10/7] for Tailwind v3+
            >
              {deviceImages.map((img, index) => (
                <SwiperSlide key={index}>
                  <img
                    src={img.src}
                    alt={img.alt}
                    // Ensure image fills the slide area correctly
                    className="w-full h-full object-cover" // Use h-full with aspect ratio on container
                    loading={index === 0 ? "eager" : "lazy"} // Keep loading optimization
                  />
                </SwiperSlide>
              ))}
              {/* Swiper's navigation/pagination elements will be added automatically */}
              {/* Removed manual buttons and dots */}
            </Swiper>

            {/* Info Box - Positioned relative to the outer div */}
            <div className="mt-6 bg-white rounded-lg p-4 shadow-lg absolute -bottom-10 left-1/2 transform -translate-x-1/2 w-4/5 z-10"> {/* Adjusted bottom, added z-10 */}
              <div className="flex items-center">
                <div className="flex-shrink-0 bg-indigo-100 p-2 rounded-full">
                  <svg className="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <div className="ml-3">
                  <p className="text-sm font-medium text-gray-900">Serving YorkgateMall</p>
                  <p className="text-sm text-gray-500">Open 7 Days a Week</p>
                </div>
              </div>
            </div>
          </div>
          {/* --- End Image Slider Column --- */}

        </div>
      </div>
    </section>
  );
};

export default HeroSection;
